<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
            {{title}}
            </div>
        </div>
        <div class="m-panel-body">
            <Echart :options="option" style="height: 100%"></Echart>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts/lib/echarts';
import {formatDecimal} from '@/utils/util'
import { getAction } from '@/api/manage'
export default {
    props: {
            titleImage: {
            type: String,
            default: ''
        },
    },
    data() {
        return{
            title: this.$t('液位'),
            option: {},
            lowWaterLinevalue: 0,
            heightWaterLinevalue: 0,
            url:{
                PWOnTimeRecord:"/jeecg-charge/wq/partPWMeterdatarecord/list"
            },
            PWOnTimeRecord:[],
        }
    },
    mounted() {
    },
    methods: {
        init() {
            this.resetData()
            this.queryPWOnTimeRecord()
        },
        resetData() {
            this.option = this.$options.data.call(this).option
        },
        queryPWOnTimeRecord() {
            let params = {deviceType: 'WM'}
            getAction(this.url.PWOnTimeRecord, params).then((res) => {
                console.log(res.success);
                if(res.success&&res.result.records.length>0){
                    this.PWOnTimeRecord = res.result.records[1];
                    if (this.PWOnTimeRecord.tepvalue == -999.9) {
                        this.PWOnTimeRecord.tepvalue = '-/-'
                    }
                    console.log(this.PWOnTimeRecord);
                    this.lowWaterLinevalue = this.PWOnTimeRecord.pvalueLow;
                    this.heightWaterLinevalue = this.PWOnTimeRecord.pvalueTop;
                    let data = {pressValue: this.PWOnTimeRecord.pvalue,title: this.$t('液位'),tempValue: this.PWOnTimeRecord.tepvalue,deviceLocation: this.PWOnTimeRecord.deviceLocation}
                    this.setOption(data);
                }else{
                    let data = {pressValue: 0.61,title: this.$t('液位'),tempValue: 6.9,deviceLocation: '小寨'}
                    this.setOption(data);
                }
            }) 
        },
        setOption(data) {
            let text = `${this.$t('安装位置')}:${data.deviceLocation}`
            this.option =  {
                title : {   
                    subtext: text,
                    show: false,
                    //x:'center',
                    //y:'80%',
                    bottom: 0,
                    left: 'center',
                    subtextStyle:{ 
                        color:'#D0EFFF',
                        align: 'center',
                        verticalAlign: 'middle',
                        fontSize: 16,
                    }
                },
                grid: {
                    x: '10',
                    y: '30',
                    x2: '30',
                    y2: '30',
                    containLabel: true
                },
                xAxis : [
                    {
                        type : 'category',
                        splitLine:false,
                        //show: false,
                        //boundaryGap: true,
                        axisLine:{
                            show: true,
                            lineStyle: {
                                color: ['#074671'],
                            }
                        },
                        data : [text],
                        axisLabel:{
                            show: true,
                            textStyle:{
                                color:'#D0EFFF',
                                align: 'center',
                                //verticalAlign: 'middle',
                                fontSize: 16,
                            }
                        }
                    }
                ],
                yAxis : [
                    {
                        name: 'm',
                        nameTextStyle: {
                            color: '#D1F3FF',
                            align: 'right'
                        },
                        type : 'value',
                        boundaryGap: [0, 0.1],
                        splitLine:{
                            show: true,
                            lineStyle: {
                                type: 'dotted',
                                color: ['#074671'],
                            }
                            
                        },
                        axisLine:{
                            show: false,
                            lineStyle:{
                                color:['rgba(151, 151, 151, 0.2)']
                            }
                        },
                        axisLabel:{
                            margin: 10,
                            align: 'right',
                            textStyle:{
                                color:['#D1F3FF'],
                                fontSize: '10',
                            },
                        },
                        axisTick: {
                        show: false
                        },
                        scale: false,
                        max: this.heightWaterLinevalue>data.pressValue?formatDecimal(this.heightWaterLinevalue+0.5, 2):formatDecimal(data.pressValue+0.5, 2)
                    }
                ],
                series : [
                    {
                        name:this.$t('液位'),
                        type:'bar',
                        barCategoryGap: '0%',
                        barWidth: '100%',
                        itemStyle: {
                            normal: {
                                color:new echarts.graphic.LinearGradient(
                                0, 0, 0, 1,
                                        [
                                    {offset: 0, color: 'rgba(0,202,167,0.2)'},
                                    //{offset: 0.5, color: '#888'},
                                    {offset: 1, color: 'rgba(210,255,247,0.00)'}
                                ] 
                                ),
                                //borderWidth: [2,0,0,0],
                                //borderColor: '#0091FF',
                                label : {
                                    z: 99,
                                    show: true, 
                                    color: '#D0EFFF',
                                    position: 'top',
                                    distance: 10,
                                    //backgroundColor: '#02266B',
                                    padding: [6,12],
                                    borderRadius: 2,
                                    formatter: `${this.$t('液位')}:${data.pressValue}m, ${this.$t('温度')}:${data.tempValue}℃`
                                }
                            }
                        },
                        data:[data.pressValue],
                        /*
                        markPoint: {
                            symbol: 'none',
                            data: [
                                {type: 'max', name: '液位值'},
                            ]
                        },
                        */
                        markLine: {
                            silent: true,
                            animationDelay: 2000,
                            animationDuration: 2000,
                            ineStyle: {
                                normal: {
                                    color: 'red',
                                    type:'dotted',
                                    //这儿设置安全基线颜色
                                }
                            },
                            symbol: ['none','arrow'],
                            data: [{
                                name:this.$t('低位告警线'),type:'min',yAxis: this.lowWaterLinevalue,lineStyle: {
                                    color: 'orange'}
                                },{
                                    name:this.$t('高位告警线'),type:'max',yAxis: this.heightWaterLinevalue,lineStyle: {
                                    color: 'red'}
                            }]
                        }
                    }
                ]
            };
        }
    }
}
</script>